import ProficiencyIcon from "./ProficiencyIcon";

export default ProficiencyIcon;
export { ProficiencyIcon };
